
import { defineComponent, ref } from 'vue'
import { SubjectMap } from '@/project-subject/subject-config/subject-config'
import { CURRENT_PROJECT_SUBJECT, setStorageSubjectId } from '@/project-subject/project-subject'

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
  },

  setup (props, context) {
    const subjectList = Object.values(SubjectMap)
    const subjectId = ref(CURRENT_PROJECT_SUBJECT.id)

    function handleClose () {
      context.emit('update:modelValue', false)
    }

    function handleConfirm () {
      setStorageSubjectId(subjectId.value)
      window.location.replace('/dashboard/overview')
    }

    return {
      subjectId,
      subjectList,
      handleConfirm,
      handleClose,
    }
  }
})
